// extracted by mini-css-extract-plugin
module.exports = {"stage":"stage_stage__fP6B8","message":"stage_message__3D_h8","scroll":"stage_scroll__10D_T"};